<template>
    <div @click="handleToggle" class="simple-toggle" :class="{ active }">
        <div class="simple-carret"></div>
    </div>
</template>

<style lang="scss" scoped>
.simple-toggle {
    cursor: pointer;
    min-height: 31px;
    width: 51px;
    background-color: rgba(236, 85, 146, 0.2);
    border-radius: 25px;
    position: relative;
    transition-property: background-color;
    transition-timing-function: ease-in-out;
    transition-duration: .2s;

    .simple-carret {
        height: 27px;
        width: 27px;
        background: #fff;
        border-radius: 100%;
        top: 2px;
        position: absolute;
        left: 2px;
        box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.15), 0px 3px 1px rgba(0, 0, 0, 0.06);
        transition-property: transform;
        transition-timing-function: ease-in-out;
        transition-duration: .2s;
    }

    &.active {
        background: #828AF7;

        .simple-carret {
            transform: translateX(calc(100% - 7px));
        }
    }
}
</style>

<script>
import { ref } from 'vue';

export default {
    name: 'SimpleToggle',
    props: {
        modelValue: {
            type: Boolean,
            default: false
        }
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        const active = ref(props.modelValue);
        return {
            active,
            handleToggle: () => {
                active.value = !active.value
                emit('update:modelValue', active.value)
            }
        }
    }
}
</script>
